// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1AL97","footer":"ModalError_footer__IZuK5"};